$a.each_current_and_future('.js-tooltip', function (el) {
  return el.tooltip();
});